import React from 'react'

const styles = {width: '99vw', height: '88vh'}

function Sintesis() {
    return (
        <iframe 
        title='Sintesis' 
        src="https://geologiaconce.maps.arcgis.com/apps/dashboards/9802ca54fc564285b14503e1de2e1fb5" 
        style={styles}></iframe>
    )
}

export default Sintesis
